import clsx from "clsx";
import { useSection } from "@tree-company/tree-query";
import { RatingIcon } from "../rating_icon";
import { Button } from "../button";

export function Rating({ question, className, handleChange }) {
  const { value, options } = useSection(question);

  return (
    <div className={clsx("rating", className)}>
      {options.map((o) => (
        <Button
          key={o.value.toString()}
          type="submit"
          variation="rating"
          className={clsx("rating__item", {
            "rating__item--unselected": value !== null && value !== o.value,
          })}
          onClick={(e) => {
            if (o.ariaDisabled) return;
            handleChange(e, o.value);
          }}
          disabled={o.disabled}
          aria-disabled={o.ariaDisabled}
          aria-pressed={value === o.value}
          icon={<RatingIcon value={o.value} />}
          srText
        >
          {o.label}
        </Button>
      ))}
    </div>
  );
}
